<template>
  <div>
    <PageHeader image="header-2" withMobile :title="$lang('title')" :breadcrumbs="$lang('breadcr')" />

    <!-- Section 1 -->
    <section class="pt-8 pb-9 bg-green2">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-5 mb-5 mb-lg-0">
            <h2 class="fw-bold text-blue1 mb-4">
              {{ $lang("section1.title") }}
            </h2>
            <p class="text-white">
              {{ $lang("section1.text") }}
            </p>
          </div>
          <div class="col-lg-6 offset-lg-1">
            <ImageContainer fileName="careers-1" class="img-container-rounded" />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader";

export default {
  components: {
    PageHeader,
  },
};
</script>
